import { create } from 'zustand';
import type { OsceMarksheet, OsceSessionDetailQuery } from '@/graphql/gql/graphql';
import type { OmitFunctions } from '@/types';
import { createSelectors } from './selector';

export type OsceMarksheetStat = NonNullable<
  NonNullable<OsceSessionDetailQuery['admin']>['osceMarksheetStat']
>;

interface OsceSessionState {
  marksheet: OsceMarksheet | null;
  stat: OsceMarksheetStat | null;
  loading: boolean;
  setMarksheet: (m: OsceMarksheet) => void;
  setStat: (s: OsceMarksheetStat) => void;
  setLoading: (v: boolean) => void;
  reset: () => void;
}

const initialState: OmitFunctions<OsceSessionState> = {
  marksheet: null,
  stat: null,
  loading: true,
};

export const osceSessionState = create<OsceSessionState>()((set) => ({
  ...initialState,
  setMarksheet: (marksheet) => set({ marksheet }),
  setStat: (stat) => set({ stat }),
  setLoading: (loading) => set({ loading }),
  reset: () => set(initialState),
}));

export const useOsceSession = createSelectors(osceSessionState);
